import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { exigir } from '../nucleo/autorizacion/guardian.js';
import { rutaRaiz } from './raiz.js';

/**
 * La única ruta accesible con la bandera de contraseña temporal arriba. Exige sesión,
 * pero pasa `permitirPasswordPendiente` para no redirigirse a sí misma en círculo.
 *
 * El componente llega a pedido, como el de cualquier ruta: solo `/ingresar` viaja en el
 * fragmento de entrada, porque es la única pantalla que alguien sin sesión puede ver.
 */
export const rutaCambiarPassword = createRoute({
  getParentRoute: () => rutaRaiz,
  path: '/cambiar-password',
  beforeLoad: ({ context }) => ({ sesion: exigir(context, { permitirPasswordPendiente: true }) }),
  component: lazyRouteComponent(
    () => import('./cambiar-password-pantalla.js'),
    'RutaCambiarPassword',
  ),
});
